const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/console/_auth/_layout/patient/$accountId_.archive.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { type PatientArchive, type PatientArchivePeisExam } from '@/api/patient';
export const Route = createFileRoute('/console/_auth/_layout/patient/$accountId_/archive')({
  validateSearch: (search: Record<string, unknown>): {
    reportId?: string;
  } => {
    const reportId = typeof search.reportId === 'string' ? search.reportId : '';
    return reportId ? {
      reportId
    } : {};
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
type TabKey = 'basic' | 'history' | 'medical' | 'questionnaire' | 'followUp';

// region 疾病史

type DiseaseHistoryRow = {
  key: string;
  code: string;
  name: string;
  department: string | null;
  // HIS 诊断填门诊 / 住院, 疾病史表的记录填它的来源
  sourceLabel: string;
  // 疾病史表的记录没有主次之分
  isMajor: boolean | null;
  diagnosedAt: string | null;
  // 就诊流水号, 同一天的诊断按就诊排在一起
  workorder: string;
  note: string | null;
};

// 疾病史 = 全部 HIS 诊断逐条列出 + 疾病史表里患者自述 / 五病筛查的记录
// HIS 诊断直接取就诊记录, 不受患者删除和回填时机影响

// endregion

// region 医疗时间轴

type HisEncounterType = 'outpatient' | 'inpatient' | 'other';
type HisEncounterTimelineItem = {
  kind: 'his';
  key: string;
  occurredAt: string | null;
  encounterType: HisEncounterType;
  encounterNo: string;
  outpatient?: PatientArchive['his']['outpatients'][number];
  inpatient?: PatientArchive['his']['inpatients'][number];
  diagnoses: PatientArchive['his']['diagnoses'];
  labReports: PatientArchive['his']['labReports'];
  examReports: PatientArchive['his']['examReports'];
  pathologyReports: PatientArchive['his']['pathologyReports'];
  orders: PatientArchive['his']['orders'];
};
type MedicalTimelineItem = {
  kind: 'peis';
  key: string;
  occurredAt: string | null;
  reportId: string;
  data: PatientArchivePeisExam;
} | HisEncounterTimelineItem;
type HisEncounterAttachment = {
  kind: 'diagnosis';
  encounterType: HisEncounterType;
  encounterNo: string;
  occurredAt: string | null;
  data: PatientArchive['his']['diagnoses'][number];
} | {
  kind: 'lab';
  encounterType: HisEncounterType;
  encounterNo: string;
  occurredAt: string | null;
  data: PatientArchive['his']['labReports'][number];
} | {
  kind: 'exam';
  encounterType: HisEncounterType;
  encounterNo: string;
  occurredAt: string | null;
  data: PatientArchive['his']['examReports'][number];
} | {
  kind: 'pathology';
  encounterType: HisEncounterType;
  encounterNo: string;
  occurredAt: string | null;
  data: PatientArchive['his']['pathologyReports'][number];
} | {
  kind: 'order';
  encounterType: HisEncounterType;
  encounterNo: string;
  occurredAt: string | null;
  data: PatientArchive['his']['orders'][number];
};

// endregion
// niceDomain 把上下界对齐到 1/2/5 系列的整齐步长，避免出现 38.7 这种刻度
// endregion
// endregion
// SwipeRow 仅对可删除行启用左滑露出删除按钮,其他行直接透传内容
// endregion
// AI 巡查风险等级 → 徽章文案与色调
// 随访状态 → 徽章文案与色调, 已取消的不会出现在首页
// 复查提醒与随访卡片的统计范围说明
// 用户来源分类与条形配色, 顺序即展示顺序; 平台是「无院内记录」的兜底类, 用中性灰
// 各指标的口径说明, 集中放一处便于核对
// endregion
// 管理视角: 超管额外看到管理归属、覆盖、活跃趋势与功能使用; 健管师 / 运营员只看基础概览
// 超管的核心指标: 用真实的活跃与新增替代原先写死的两项 100%
// region 复查提醒与患者随访
// 管理视角和医生工作台共用, 统计范围由服务端按角色决定, 卡片描述里写明
// 上面一排底色统计格, 下面是近 7 天的明细列表
// endregion
// 用户来源分布: 横向条形, 全为 0(含数据未就绪)时按无数据占位
// 指标行:仿模板 KPI 行;纯数字走 KPI.Value,带 % 等符号的直接文本渲染
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}